import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungDarmstadt() {
  return (
    <CityPageTemplate
      city="Darmstadt"
      slug="darmstadt"
      intro="Darmstadt als Wissenschaftsstadt – Deine Finanzplanung sollte genauso zukunftsorientiert sein."
      description="Unabhängige & digitale Finanzberatung für Darmstadt: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
